import React, { useState, useEffect } from "react";
import DeleteModalComponent from "../../../Common/DeleteModal";
import WorkProgramEdit from "./workProgramEdit";
import PropTypes from 'prop-types';
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
import {Table, Column} from "@appkit4/react-components/table";

export default function WorkProgram(props) {
  const { workProgramData, role, getWPRequest } = props;
  const [wpId, setWpId] = useState("");
  const [userId, setUserId] = useState();
  const [wpData, setWPData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [view, setView] = useState(false);
  const [editScreen, setEditScreen] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [assessorId, setAssessorId] = useState("");
  const [planId, setPlanId] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: selectWorkPrograms } = useHttp();
  const getvendors = async () => {
    getAllVendorList(APIService.getAllVendorList(), (res) => {
      if (res.CODE) {
        setVendors(res.MSG);
      }
    })
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const getByWPRequestID = async (ID, vendorid) => {
    selectWorkPrograms(APIService.selectWorkPrograms(ID, vendorid), (res) => {
      setWPData(res.MSG);
      setEditScreen(true);
    })
  };

  useEffect(() => {
    setEditScreen(false);
    getvendors();
    setTableData(workProgramData);
    setFilter(workProgramData);
    let totalPageLength = Math.ceil((workProgramData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [workProgramData]);

  useEffect(() => {
    const result = tableData?.filter((wpList) => {
      return wpList?.vendorName.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
  }, [search]);

  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const handelEditScreen = () => {
    setTableData(workProgramData);
    setFilter(workProgramData);
    let totalPageLength = Math.ceil((workProgramData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
    setEditScreen(false);
    getWPRequest();
  };

  const renderNextPlannedDate = (row) => {
    return formatDate(row?.nextPlannedDate);
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.vendorName).charAt(1);
    const secondOrderId = (b.vendorName).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

  const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.vendorName).charAt(1);
    const secondOrderId = (b.vendorName).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
  }

  const renderActionCell = (row) => {
    return (
      <>
      <span className=" Appkit4-icon icon-view-fill pointer action-icon" title="View request" onClick={() => handleViewButton(row)}></span>&nbsp;
      <span className=" Appkit4-icon icon-edit-fill pointer action-icon" title="Edit request" onClick={() => handleEditButton(row)}></span>&nbsp;
      <span className=" Appkit4-icon icon-delete-fill pointer action-icon" title="Delete request" onClick={() => handleDeleteButton(row)}></span>
      </>
    )
  }

  const handleViewButton = (row) => {
    getByWPRequestID(row?.workprogramid, row?.vendorassreqid);
    setView(false);
  }

  const handleEditButton = (row) => {
    getByWPRequestID(row?.workprogramid, row?.vendorassreqid);
    setWpId(row?.workprogramid);
    setRequestId(row?.vendorassreqid);
    setPlanId(row?.vendorassplanid);
    setVendorId(row?.vendorid);
    setAssessorId(row?.assessor_id);
    setView(true);
  }

  const handleDeleteButton = (row) => {
    setModalVisible(true);
    setEditScreen(false);
    setWpId(row?.vendorid);
    setUserId(row?.createdby);
  }

  return (
    <div className="App">
      {editScreen ? (
        <WorkProgramEdit
          sendBack={handelEditScreen}
          View={view}
          vendors={vendors}
          WorkProgramID={wpId}
          VendorId={vendorId}
          WPRequestData={wpData}
          PlanId={planId}
          RequestId={requestId}
          AssessorId={assessorId}
          role={role}
        />
      ) : (
        <div className="col-lg-12 mt-3 pl-1">
          {tableData.length > 0 ? (
            <Input
            type="text"
            title= "Search Third Party Name"
            value={search}
            className="ap-field-wrapper-tableSearch"
            onChange={(e) => setSearch(e)}
          /> 
          ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="vendorName" sortKey={filter.length > 0 ? "vendorName" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Third Party Name</Column>
                    <Column field="frequency" sortKey={filter.length > 0 ? "frequency" : ""}>Frequency</Column>
                    <Column field="recurrenceMonths" sortKey={filter.length > 0 ? "recurrenceMonths" : ""}>Recurrence</Column>
                    <Column field="nextPlannedDate" sortKey={filter.length > 0 ? "nextPlannedDate" : ""} renderCell={renderNextPlannedDate}>Next Planned</Column>
                    <Column field="assessmentType" sortKey={filter.length > 0 ? "assessmentType" : ""}>Assessment Type</Column>
                    <Column field="assessor" sortKey={filter.length > 0 ? "assessor" : ""}>Assessor</Column>
                    <Column field="manager" sortKey={filter.length > 0 ? "manager" : ""}>Manager</Column>
                    <Column field="workprogramid"
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
          <DeleteModalComponent
            content={
              "Are you sure you want to delete this third party account?"
            }
            visible={modalVisible}
            cancel={handleCancel}
            // confirm={() => handleDelete(wpId, userId)}
          />
        </div>
      )}
    </div>
  );
}
WorkProgram.propTypes = {
  workProgramData:PropTypes.array,
  handleDelete:PropTypes.func,
  getWPRequest:PropTypes.func,
  role:PropTypes.any
}
